export var RecurringSuggestionStatus;
(function (RecurringSuggestionStatus) {
    RecurringSuggestionStatus["PENDING"] = "PENDING";
    RecurringSuggestionStatus["DISMISSED"] = "DISMISSED";
    RecurringSuggestionStatus["CONFIRMED"] = "CONFIRMED";
})(RecurringSuggestionStatus || (RecurringSuggestionStatus = {}));
//# sourceMappingURL=recurring-suggestion-status.enum.js.map